import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "../../layouts/Auth.css";
import { config } from "../../config";

function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleRegister = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      await axios.post(`${config.apiBaseUrl}/auth/signup`, {
        name: name,
        email: email,
        password: password,
      });
      setSuccess("Registration successful! Please login.");
      setTimeout(() => navigate("/login"), 2000);
    } catch (error: any) {
      console.error("Registration error:", error);
      if (error.response?.data) {
        setError(error.response.data.message || "Registration failed");
      } else {
        setError("Registration failed. Please try again.");
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <Link to="/" className="auth-brand" aria-label="iFoto home">
          <img className="auth-brand-logo" src="/stillwave-logo.svg" alt="" />
        </Link>

        <h1 className="auth-title">Create account</h1>
        <p className="auth-subtitle">Join iFoto to share your photography with the world.</p>

        <form className="auth-form" onSubmit={handleRegister}>
          <label className="auth-field">
            Name
            <input
              type="text"
              placeholder="Your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </label>

          <label className="auth-field">
            Email
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>

          <label className="auth-field">
            Password
            <input
              type="password"
              placeholder="Choose a password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>

          <label className="auth-field">
            Confirm Password
            <input
              type="password"
              placeholder="Repeat your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </label>

          {error && <div className="auth-error">{error}</div>}
          {success && <div className="auth-success">{success}</div>}

          <div className="auth-actions">
            <button type="submit" className="btn primary">
              Register
            </button>
          </div>
        </form>

        <p className="auth-alt">
          Already have an account?{" "}
          <button type="button" className="auth-link" onClick={() => navigate("/login")}>
            Login here
          </button>
        </p>
      </div>
    </div>
  );
}

export default Register;